import React, { Component } from "react";
import Select from "react-select";

const SelectInput_3 = ({
  options,
  defaultValue,
  className,
  onChange,
  isDisabled = false,
  isClearable = true,
  value,
  components,
  isMulti = false,
  field,
  isLoading,
  name,
}) => {
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      background: isDisabled ? "#FAFAFA" : "#ffffff",
      borderColor: "#edebeb",
      minHeight: "28px",
      height: "9px",
      boxShadow: state.isFocused ? null : null,
      fontSize: "12px",
    }),
    option: (provided, state) => ({
      ...provided,
      active: "",
      //  padding: "3px",

      color: state.isSelected ? "white" : "black",
      fontSize: "12px",
    }),
    menu: (provided, state) => ({
      ...provided,
      overflowX: "auto",
      //padding: "0px 6px",
      minHeight: "auto",
      maxHeight: "auto",
      zIndex: "10px",
    }),
    // placeholder: (provided, state) => ({
    //   ...provided,
    //   overflowX: "auto",
    //   marginLeft: "0px ",
    //   marginRight: "-3px",
    // }),

    valueContainer: (provided, state) => ({
      ...provided,
      height: "28px",
      // padding: "0px 6px",
      fontSize: "12px",
    }),

    input: (provided, state) => ({
      ...provided,
      // margin: "0px",
      fontSize: "12px",
    }),
    // indicatorSeparator: (state) => ({
    //   display: "none",
    // }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: "28px",
      margin: "0px",
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };
  return (
    <div className="w-full">
      <Select
        {...field}
        className={`basic-multi-select ${className} ${
          isDisabled && "opacity-50"
        }`}
        components={components}
        menuPortalTarget={document.body}
        styles={customStyles}
        options={options}
        onChange={onChange}
        isSearchable
        isDisabled={isDisabled}
        isClearable={isClearable}
        defaultValue={defaultValue}
        value={value}
        isMulti={isMulti}
        tabSelectsValue={false}
        isLoading={isLoading}
      />
    </div>
  );
};

export default SelectInput_3;
